<template>
  <div class="containerFw">
    <div class="tools">
      <!-- <div :class="active == index ? 'toolClassActive' : 'toolClass'" v-for="(item, index) in toolArry" :key="index"
                @click="toolClick(item, index)">
                <a-icon v-if="item.name != '上传'" :type="item.icon" />
                <span v-if="item.name != '上传'">{{ item.name }}</span>
                <a-upload v-if="item.name == '上传'" name="file" :multiple="false" :before-upload="beforeUpload"
                    :customRequest="customRequest" :openFileDialogOnClick="openFileDialog" :fileList="fileList"
                    :showUploadList="false">
                    <a-button style="width:100px;margin-left:-7px;color:#ffffff;" type="link"
                        @click="() => toUpload()"><a-icon type="cloud-upload" />上传</a-button>
                </a-upload>
            </div> -->
      <div v-if="showBuffer">
        <a-row>
          <a-col :span="7"><span>缓冲半径：</span></a-col>
          <a-col :span="6"
            ><a-input
              class="input"
              v-model="bufferRadius"
              type="number"
              :min="0.1"
              style="background: rgba(255, 255, 255, 0.1); border: 0"
            ></a-input
          ></a-col>
          <a-col :span="4"><span>米</span></a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="7"><span>绘制：</span></a-col>
          <a-col :span="16">
            <a-button class="toolBtn" type="primary" @click="bufferAnalysis('polyline')">线</a-button>
            <a-button class="toolBtn" type="primary" @click="bufferAnalysis('polygon')">面</a-button>
          </a-col>
        </a-row>
      </div>
      <div style="margin-bottom: 10px" v-else>
        <span style="font-size:16px">选择范围：</span>
        <a-upload
          name="file"
          :multiple="false"
          :before-upload="beforeUpload"
          :customRequest="customRequest"
          :openFileDialogOnClick="openFileDialog"
          :fileList="fileList"
          accept='.zip'
          :showUploadList="false"
        >
          <a-button class="toolBtn" type="primary" @click="() => toUpload()">上传</a-button>
        </a-upload>
        <a-button class="toolBtn" type="primary" @click="() => drawRectangle({ name: '多边形', type: 'polygon' })"
          >手绘</a-button
        >
        <a-button class="toolBtn" type="primary" @click="() => selectLayer()">选择图斑</a-button>
      </div>
    </div>

    <!-- <div class="toolInfo">
        <span v-if="showUpload">支持上传SHP(zip格式)/ZIP/EXCEL/TXT/DWG/DGN</span>
        <div v-if="showDraw" class="drawClass">
            <div :class="shapeActive == index ? 'shapeClassActive' : 'shapeClass'" v-for="(item,index) in shapeArry" :key="index"  @click="drawRectangle(item,index)">{{ item.name }}</div>
        </div>
    </div> -->
    <!-- <div class="oprateMethod"> -->
      <!-- <span>手绘</span> -->
      <!-- <div class="oprateIcon">
        <a-button class="saveBtn" type="primary" @click="operateSave">批量保存</a-button> -->
        <!-- <a-icon type="save" style="margin-left: 1px;" @click="operateSave" /> -->
        <!-- <a-icon class="iconBtn" type="down" v-if="!oprateInfoShow" @click="operateShow" />
                <a-icon class="iconBtn" type="up" v-else @click="operateShow" /> -->
      <!-- </div> -->
    <!-- </div> -->
    <div class="oprateInfo" v-if="oprateInfoShow">
      <a-table
        class=""
        ref="table"
        bordered
        size="middle"
        rowKey="bsm"
        :scroll="{ x: 400, y: 150 }"
        :customRow="rowClick"
        :rowClassName="rowClassName"
        :columns="columns"
        :data-source="oprateInfoArry"
        :rowSelection="{
          selectedRowKeys: bdcRowKeys,
          onChange: onSelectChange,
          type: 'checkbox',
        }"
        :pagination="false"
        :loading="tableLoading"
      >
        <template slot="name" slot-scope="text, record">
          <editable-cell :text="text" @change="onCellChange(record.bsm, 'name', $event)" />
        </template>
        <span slot="action" slot-scope="text, record">
          <span style="display: flex; justify-content: space-between">
            <a-button type="link" class="primaryColor" @click="saveLayerMethod(record)">保存</a-button>
            <a-button type="link" class="primaryColor" :loading="buttonLoading" @click="analysis(record)">分析</a-button>
            <a-button type="link" class="primaryColor" @click="positionTo(record)">定位</a-button>
            <a-button style="color: #ff5a5a" type="link" @click="deleteLayer(record)">删除</a-button>
            <!-- <a-icon type="save" @click="saveLayerMethod(record)" />
                        <a-icon type="line-chart" @click="analysis(record)" />
                        <a-icon type="environment" @click="positionTo(record)" />
                        <a-icon type="delete" @click="deleteLayer(record)" /> -->
          </span>
        </span>
      </a-table>
    </div>
    <addLayer-dialog
      ref="addLayerDialog"
      :map="map"
      :selectLayerBsm="selectLayerBsm"
      :dialogTitle="dialogTitle"
      :myCollectionTreeData='myCollectionTreeData' 
      v-on="$listeners"
    ></addLayer-dialog>
    <selectLayer-dialog ref="selectLayerDialog" :myCollectionTreeData='myCollectionTreeData' @showLayers="showLayers"></selectLayer-dialog>
    <screen-shot-dialog ref="screenShotDialog" @handleShot="handleShot"></screen-shot-dialog>
  </div>
</template>
  
<script>
import { HandleTableCells } from '../../../../mixins/HandleTableCells'
import addLayerDialog from './addLayerDialog.vue'
import selectLayerDialog from './selectLayerDialog.vue'
import EditableCell from '../../../components/editFwcellDialog.vue'
import shp from 'shpjs'
import screenShotDialog from './screenShotDialog.vue'
import dy3dMap from '../../../js/dy3dMap.js'
const DYMAP = new dy3dMap()
export default {
  name: 'selectFwComponent',
  components: {
    addLayerDialog,
    selectLayerDialog,
    EditableCell,
    screenShotDialog,
  },
  mixins: [HandleTableCells],
  props: {
    map: {},
    fwData: {
      type: Array,
      default: () => [],
    },
    // 选择的图层bsm
    selectLayerBsm: {
      type: String,
      default: '',
    },
    // 弹框标题
    dialogTitle: {
      type: String,
      default: '',
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    myCollectionTreeData:{
      type: Array,
      default: () => [],
    }
  },
  watch: {
    fwData: {
      handler(val, oldval) {
        if (val.length > 0) {
          this.oprateInfoArry = val
        }
      },
      deep: true,
      immediate: true,
    },
    oprateInfoArry: {
      handler(val, oldval) {
        this.$nextTick(() => {
          this.changeOddTrBg()
        })
      },
      deep: true,
    },
  },
  data() {
    return {
      active: -1,
      shapeActive: -1,
      geoJsonLayer: null,
      graphicLayerMap: null,
      openFileDialog: false,
      showUpload: false,
      showDraw: false,
      oprateInfoShow: true,
      tableLoading: false,
      layerName: null,
      highlightRow: '',
      toolArry: [
        {
          icon: 'highlight',
          name: '上传',
        },
        {
          icon: 'highlight',
          name: '手绘',
        },
        {
          icon: 'check-circle',
          name: '选择',
        },
        {
          icon: 'delete',
          name: '清除',
        },
        {
          icon: '',
          name: '查询',
        },
      ],
      shapeArry: [
        { name: '多边形', type: 'polygon' },
        { name: '矩形', type: 'rectangle' },
        { name: '圆形', type: 'circle' },
      ],
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          // width: 150,
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      bdcRowKeys: [],
      csArr: [],
      oprateInfoArry: [],
      tableList: [],
      // 自动回显图斑的数组
      geoJsonArry: [],
      // 上传shp文件列表
      fileList: [],
      //queryMapserver
      queryMapserver: null,
      queryGeojsonLayer: null,
      styleFieldOptions: {
        '0204': {
          color: 'rgba(255,159,127,0.9)',
        },
        '1104A': {
          color: 'rgba(255,127,159,0.9)',
        },
        1006: {
          color: 'rgba(192,192,192,0.9)',
        },
        '0204K': {
          color: 'rgba(255,159,127,0.9)',
        },
        '1104K': {
          color: 'rgba(255,127,159,0.9)',
        },
        '0201K': {
          color: 'rgba(255,159,127,0.9)',
        },
        '0203K': {
          color: 'rgba(127,95,63,0.9)',
        },
        '0202K': {
          color: 'rgba(41,165,0,0.9)',
        },
        1104: {
          color: 'rgba(127,255,255,0.9)',
        },
        '1107A': {
          color: 'rgba(153,38,0,0.9)',
        },
        '0103': {
          color: 'rgba(153,38,0,0.9)',
        },
        '0201': {
          color: 'rgba(255,159,127,0.9)',
        },
        '0203': {
          color: 'rgba(127,95,63,0.9)',
        },
        1103: {
          color: 'rgba(127,255,255,0.9)',
        },
        '0102': {
          color: 'rgba(153,38,0,0.9)',
        },
        '0101': {
          color: 'rgba(153,38,0,0.9)',
        },
        1107: {
          color: 'rgba(153,38,0,0.9)',
        },
        1203: {
          color: 'rgba(153,38,0,0.9)',
        },
        '0202': {
          color: 'rgba(41,165,0,0.9)',
        },
        1202: {
          color: 'rgba(153,38,0,0.9)',
        },
      },
      showBuffer: false,
      bufferRadius: 100,
      bufferLayer:null,
    }
  },
  created() {
    // try {
    //   this.$bus.$on('getQueryData', (data) => {
    //     this.queryMapserver = data
    //     console.log('getQueryData', data)
    //   })
    // } catch (error) {
    //   console.log('getQueryDataERROR', error)
    // }
  },
  methods: {
    // 上传方法
    toUpload() {
      this.openFileDialog = true
    },
    // 选择图斑
    selectLayer() {
      this.$refs.selectLayerDialog.setMap()
      // this.$refs.selectLayerDialog.showMode = true
    },
    // 工具点击方法
    toolClick(item, index) {
      this.active = index
      if (item.name == '上传') {
        this.openFileDialog = true
      } else if (item.name == '手绘') {
        this.showUpload = false
        this.showDraw = false
        this.drawRectangle({ name: '多边形', type: 'polygon' })
      } else if (item.name == '选择') {
        this.showUpload = false
        this.showDraw = false
        this.$refs.selectLayerDialog.setMap()
      } else if (item.name == '清除') {
        this.showUpload = false
        this.showDraw = false
        this.clearAll()
      }
    },
    // 删除列表文件
    deleteShp() {
      this.fileList = []
    },
    // 上传文件前校验
    beforeUpload(file) {
      const type = file.name.split('.')[1]
      const isJpgOrPng = type === 'zip'
      if (!isJpgOrPng) {
        this.$message.error('只能上传zip格式的文件!')
      }
      const isLt40K = file.size / 1024 < 500
      if (!isLt40K) {
        this.$message.error('文件不得大于500KB!')
      }
      return isJpgOrPng && isLt40K
    },
    // 上传文件
    customRequest(data) {
      const self = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(data.file)
      reader.onload = function () {
        // eslint-disable-next-line no-undef
        shp(this.result).then(
          (geojson) => {
            if (geojson.features && geojson.features.length === 0) {
              self.$message.error('数据存在问题，请重新上传！')
              self.deleteShp()
            } else if (geojson.features.length > 1) {
              self.$message.error('数据是多面对象，请重新上传！')
              self.deleteShp()
            } else {
              let obj = {}
              obj.bsm = geojson.features[0].properties.id
              obj.name = '多边形'
              obj.type = 'Polygon'
              obj.style = {
                color: '#00ffff',
                opacity: 0.3,
                outline: false,
                outlineWidth: 1,
                outlineColor: '#ffffff',
                clampToGround: true, //	是否贴地
                hasEdit: true,
              }
              obj.pointArry = geojson.features[0].geometry.coordinates
              obj.tcLayer = geojson.features[0]
              self.oprateInfoArry.push(obj)
              self.tableList = JSON.parse(JSON.stringify(self.oprateInfoArry))
              self.oprateInfoShow = true
              self.initGeoJsonLayer(obj.tcLayer, obj.style)
            }
          },
          (error) => {
            self.deleteShp()
            self.$message.error('上传文件不正确')
          }
        )
      }
      reader.onerror = function (event) {
        self.$message.error('上传失败')
        reader.abort()
        self.deleteShp()
      }
    },
    //清除数据
    clearAll() {
      this.oprateInfoArry = []
      this.tableList = []
      this.map.graphicLayer.clear()
      if (this.geoJsonArry.length > 0) {
        for (var item of this.geoJsonArry) {
          item.remove(true)
        }
      }
      // 清除缓冲分析的图层
      let obj = {
        map:this.map,
        attr:'name',
        attrValue:'缓冲分析图层'
      }
      DYMAP.removeLayerByAttr(obj)
      this.bufferLayer = null
      this.geoJsonArry = []
      this.csArr = []
      this.bdcRowKeys = []
      this.queryGeojsonLayer.clear()
    },
    // 清除指定图层
    deleteLayer(item) {
      console.log(item)
      let key = item.bsm
      let layerId = item.layerId
      if (this.map.graphicLayer.getGraphicById(key)) {
        this.map.graphicLayer.getGraphicById(key).remove(true)
      } else {
        for (var j = 0; j < this.geoJsonArry.length; j++) {
          if (this.geoJsonArry[j].options.id == key) {
            this.geoJsonArry[j].remove(true)
            this.geoJsonArry.splice(j, 1)
          }
        }
      }
      for (var i = 0; i < this.oprateInfoArry.length; i++) {
        if (key == this.oprateInfoArry[i].bsm) {
          this.oprateInfoArry.splice(i, 1)
          this.tableList.splice(i, 1)
        }
      }
      //按行移除查询结果
      if (this.bufferLayer && this.bufferLayer.getGraphicById(key)) {
        let bufferKey = key + '_buffer'
        this.bufferLayer.getGraphicById(bufferKey).remove(true)
        this.bufferLayer.getGraphicById(key).remove(true)
      }
      if (this.map.getLayerById(key)) {
        console.log(this.map.getLayerById(key))
        this.map.getLayerById(key).remove(true)
      }
      if (this.map.getLayerById(layerId)) {
        this.map.getLayerById(layerId).remove(true);
      }

      this.bdcRowKeys = this.bdcRowKeys.filter(key => key != item.bsm)
      this.csArr = this.csArr.filter(e => e.bsm != item.bsm)
      this.$emit('getFwdata', this.csArr)

      this.$emit('deleteFw')

      // this.map.getLayerById(item.bsm).remove(true)
    },
    //缓冲区分析
    bufferAnalysis(type) {
      this.bufferLayer = new mars3d.layer.GraphicLayer({
        // id:'buffer-layer',
        name: '缓冲分析图层',
      })
      this.map.addLayer(this.bufferLayer)

      var style = {}
      if (type == 'polyline') {
        style = {
          color: '#ffff00',
          width: 3,
          clampToGround: false,
        }
      } else {
        style = {
          color: '#ffff00',
          outline: true,
          outlineColor: '#f0ce22',
          outlineWidth: 4,
          opacity: 0.5,
          clampToGround: true,
        }
      }
      this.bufferLayer.startDraw({
        type: type,
        style: style,
        success: (graphic) => {
          console.log('graphic', graphic)
          var cartesian3 = graphic._positions_draw
          if (type == 'polygon') {
            cartesian3.push(cartesian3[0])
          }
          // 空间直角坐标转经纬度
          var points = []
          var buffered = null
          var poly = null
          cartesian3.map((item) => {
            var cartographic = Cesium.Cartographic.fromCartesian(item)
            var lat = Cesium.Math.toDegrees(cartographic.latitude)
            var lng = Cesium.Math.toDegrees(cartographic.longitude)
            // var height = cartographic.height;
            points.push([lng, lat])
          })
          if (type == 'polygon') {
            poly = turf.polygon([points])
          } else {
            poly = turf.lineString(points)
          }
          buffered = turf.buffer(poly, this.bufferRadius, { units: 'meters' })
          const graphicsOptions = mars3d.Util.geoJsonToGraphics(buffered, {
            type: 'polygon',
            style: {
              color: '#abf7a6',
              opacity: 0.7,
              outline: true,
              outlineColor: '#01c001',
              outlineWidth: 4,
              clampToGround: true,
            },
          })
          graphicsOptions[0].id = graphic.id + '_buffer'
          this.bufferLayer.addGraphic(graphicsOptions)
          // var tcLayer = graphicsOptions.toGeoJSON()
          buffered.properties.id =graphicsOptions[0].id
          buffered.properties.type =graphicsOptions[0].type
          buffered.properties.style =graphicsOptions[0].style
          var obj = {};
          obj.bsm = graphic.id;
          obj.layerId = graphic._layer.options.id, obj.name = '缓冲区';
          obj.type = type
          obj.style = style
          obj.pointArray = points
          obj.tcLayer = graphic.toGeoJSON()
          obj.bufferLayer = {
            type: 'Polygon',
            style: graphicsOptions.style,
            pointArry: buffered.geometry.coordinates,
            tcLayer: buffered
          }      
          obj.analysisType = 'hcfx' // 如果包含这个属性则就是缓冲分析，否则为叠加分析

          if (obj) {
            this.oprateInfoArry.push(obj)
            this.tableList = JSON.parse(JSON.stringify(this.oprateInfoArry))
            this.oprateInfoShow = true
          }
          // map.graphicLayer.addGraphic(graphicsOptions)
          console.log('map2', this.map, this.map.getLayers())
        },
      })
    },
    /**
     * 单个图斑的分析方法
     * @param {string} record.bsm  图斑bsm
     * @param {string} record.dkmj 图斑面积
     * @param {string} record.name 图斑名称
     * @param {array} record.pointArry  图斑范围坐标
     * @param {object} record.style 图斑样式
     * @param {object} record.tcLayer  渲染图斑的数据 {geometry:{}, properties:{}, type:'Feature'}
     */
    analysis(record) {
      console.log('record分析', record)
      if(!this.selectLayerBsm){
        this.$message.warning('请选择图层')
        return
      }
      let newArry = []
      newArry.push(record)
      this.bdcRowKeys = [record.bsm]
      this.csArr = [record]
      this.$emit('getFwdata', this.csArr)
      if (newArry.length > 0) {
        this.$emit('goSingalStatic', newArry)
      }
      //空间查询分析
      // this.queryGeojsonLayer = new this.mars3d.layer.GeoJsonLayer({
      //     id: record.bsm,
      //     name: '',
      //     symbol: {
      //         type: "polygonP",
      //         styleOptions: {
      //             color: "rgba(205, 233, 247, 0.7)", // 填充颜色
      //             clampToGround: true
      //         },
      //         styleField: "DLBM",//要用编码不能中文，否则styleFieldOptions不生效
      //         styleFieldOptions: this.styleFieldOptions
      //     },
      //     popup: "名称：{DLMC}<br />编号：{DLBM}<br />面积：{muArea}㎡"
      // })
      // this.map.addLayer(this.queryGeojsonLayer)
      // //   if (this.drawGraphic == null) {
      // //       this.$message.warning('未绘制查询区域!')
      // //       return
      // //   }
      // //加载数据到矢量图层
      // let graphic = new this.mars3d.graphic.PolygonEntity({
      //     positions: record.pointArry,
      //     style: record.tcLayer.properties.style,
      // })

      // this.queryMapserver.query({
      //     column: "",
      //     text: '',
      //     graphic: graphic,
      //     page: false,
      //     success: (result) => {
      //         if (result.count === 0) {
      //             this.$message.warning('未查询到相关记录！')
      //             return
      //         }
      //         console.log("查询到的记录", result)
      //         const drawGeoJSON = graphic.toGeoJSON({ outline: true })

      //         const arrArea = []
      //         const arrFeatures = result.geojson.features
      //         for (let i = 0; i < arrFeatures.length; i++) {
      //             const feature = arrFeatures[i]
      //             try {
      //                 const geojsonNew = turf.intersect(drawGeoJSON, feature) // 切割
      //                 if (geojsonNew) {
      //                     feature.geometry = geojsonNew.geometry
      //                 }
      //             } catch (e) {
      //                 this.$message.error("切割异常，请重新切割");
      //             }

      //             const area = turf.area(feature) || feature.properties.Shape_Area || 0
      //             feature.properties.muArea = area // 平方米
      //             //   feature.properties.muArea = mars3d.Util.formatNum(area * 0.0015, 2) // 平方米转亩

      //             // 需要统计的数据
      //             arrArea.push({
      //                 type: feature.properties.DLMC,
      //                 area: feature.properties.muArea
      //             })
      //         }

      //         // 显示数据
      //         this.queryGeojsonLayer.load({ data: result.geojson })
      //     },
      //     error: (error, msg) => {
      //         this.$message.error("服务访问错误!");
      //         //   console.log("服务访问错误", error)
      //     }
      // })
    },
    // 保存图斑方法（点击表格行按钮）
    saveLayerMethod(item) {
      this.$refs.screenShotDialog.open(item)
    },
    // 截图的回调
    handleShot(file,info) {
      if(!file){
        // 说明点击的是取消或关闭截图
        return
      }
      if(Array.isArray(info)){
        // 批量保存图斑  截图后的回调
        info.map(item => {
          item.file = file
          item.dataFrom = this.dialogTitle
        })
      }else{
        // 点击表格行的保存按钮 截图后的回调
        info.file = file
        info.dataFrom = this.dialogTitle
      }
      this.$refs.addLayerDialog.setMap(info)
    },
    // 对已确定的图斑进行查询
    onSearch() {
      if (this.layerName) {
        let reg = new RegExp(this.layerName)
        let list = this.tableList.filter((item) => reg.test(item.name))
        this.oprateInfoArry = list
      } else {
        this.oprateInfoArry = this.tableList
      }
    },
    // 批量保存图斑
    operateSave() {
      if (this.oprateInfoArry.length > 0) {
        if (this.csArr.length > 0) {
          this.$refs.screenShotDialog.open(this.csArr)
        } else {
          this.$message.warning('请先勾选要保存的图斑范围')
        }
      } else {
        this.$message.warning('请先绘制或者选择分析范围')
      }
    },
    // 图斑信息显示与隐藏
    operateShow() {
      if (this.oprateInfoShow) {
        this.oprateInfoShow = false
      } else {
        this.oprateInfoShow = true
      }
    },
    // 复选框点击事件
    onSelectChange(bdcRowKeys, record) {
      this.bdcRowKeys = bdcRowKeys
      this.csArr = record
      this.$emit('getFwdata', this.csArr)
    },
    // 表格行属性
    rowClassName(record, index) {
      return this.highlightRow === record.bsm ? 'hightlight' : ''
    },
    // 表格点击事件
    rowClick(record, index) {
      var _this = this
      return {
        on: {
          click: (e) => {
            _this.index = index
            _this.highlightRow = record.bsm
          },
          dblclick: () => {},
        },
      }
    },
    // 图斑区域飞入方法
    positionTo(record) {
      if(record.layerId){
        // 缓冲分析的图斑定位
        if (this.map.getLayerById(record.bsm)) {
          this.map.getLayerById(record.bsm).flyTo();
        } else {
          if(this.map.getLayerById(record.layerId)){
            this.map.getLayerById(record.layerId).flyTo()
          }          
        }
      }else{
        // 叠加分析的图斑定位
        if (this.map.graphicLayer.getGraphicById(record.bsm)) {
          this.map.graphicLayer.getGraphicById(record.bsm).flyTo()
        } else {
          if(this.geoJsonArry.length > 0){
            for (var item of this.geoJsonArry) {
              if (item.options.id == record.bsm) {
                item.flyTo()
              }
            }
          }else{
            this.map.getLayerById(record.bsm) && this.map.getLayerById(record.bsm).flyTo();
          }
        }
      }
    },
    // 地图手绘方法
    drawRectangle(item, index) {
      let that = this
      that.shapeActive = index
      that.map.graphicLayer.startDraw({
        type: item.type,
        style: {
          color: '#00ffff',
          opacity: 0.3,
          outline: false,
          outlineWidth: 1,
          outlineColor: '#ffffff',
          clampToGround: true, //	是否贴地
          hasEdit: true,
        },
        success: function (graphic) {
          var graphicObj = graphic
          var tcLayer = graphic.toGeoJSON()
          var area = turf.area(tcLayer)
          if (tcLayer) {
            let obj = {}
            obj.bsm = graphicObj.id
            if (tcLayer.properties.type == 'polygon') {
              obj.name = '多边形'
              obj.type = 'Polygon'
              obj.style = tcLayer.properties.style
              obj.pointArry = tcLayer.geometry.coordinates
              obj.tcLayer = tcLayer
              obj.dkmj = (area / 10000).toFixed(3)
            } else if (tcLayer.properties.type == 'rectangle') {
              obj.name = '矩形'
              obj.type = 'rectangle'
              obj.style = tcLayer.properties.style
              obj.pointArry = tcLayer.geometry.coordinates
              obj.tcLayer = tcLayer
            } else {
              obj.name = '圆形'
              obj.type = 'circle'
              obj.style = tcLayer.properties.style
              obj.pointArry = tcLayer.geometry.coordinates
              obj.tcLayer = tcLayer
            }
            if (obj) {
              that.oprateInfoArry.push(obj)
              that.tableList = JSON.parse(JSON.stringify(that.oprateInfoArry))
              that.oprateInfoShow = true
              that.$emit('setTableHeight')
            }
          }
        },
      })
    },
    /**
     * 初始化GeoJson自定义图层
     */
    initGeoJsonLayer(item) {
      this.geoJsonLayer = new mars3d.layer.GeoJsonLayer({
        name: '手绘图层',
        data: item.analysisType ? item.bufferLayer.tcLayer : item.tcLayer,
        symbol: {
          type: 'polygonP', //面
          styleOptions: item.analysisType ? item.bufferLayer.tcLayer.style : item.tcLayer.style
        },
      })
      // 缓冲分析的分析图层展示
      if(item.analysisType){
        this.geoJsonLineLayer = new mars3d.layer.GeoJsonLayer({
          name: '手绘图层',
          data: item.tcLayer,
          symbol: {
            type: 'polylineP',
            //面
            styleOptions: item.tcLayer.style
          }
        });
        this.geoJsonLineLayer.options.id = item.layerId
        this.map.addLayer(this.geoJsonLineLayer);
      }
      this.geoJsonLayer.options.id = item.analysisType ?  item.bsm : item.tcLayer.properties.id
      this.geoJsonArry.push(this.geoJsonLayer)
      this.map.addLayer(this.geoJsonLayer)
    },
    //   可编辑单元格（显示排序）
    onCellChange(bsm, dataIndex, value) {
      const dataSource = [...this.oprateInfoArry]
      const target = dataSource.find((item) => item.bsm === bsm)
      if (target) {
        target[dataIndex] = value
        this.oprateInfoArry = dataSource
      }
    },
    // 回显图斑内容
    showLayers(msg) {
      for (var item of msg) {
        this.oprateInfoArry.push(JSON.parse(item))
        if (this.geoJsonArry.every((menu) => menu.options.id != JSON.parse(item).bsm)) {
          this.initGeoJsonLayer(JSON.parse(item).tcLayer, JSON.parse(item).style)
        }
      }
      this.oprateInfoArry = this.uniqueArray(this.oprateInfoArry)
      this.oprateInfoShow = true
    },
    // 数组对象去重方法
    uniqueArray(arr) {
      let bsm = 'bsm'
      let map = new Map()
      for (let item of arr) {
        if (!map.has(item.bsm)) {
          map.set(item.bsm, item)
        }
      }
      return [...map.values()]
    },
  },
}
</script>
  
<style lang="less" scoped>
.containerFw {
  width: 100%;
  height: 100%;

  // border: 1px solid red;
  .tools {
    width: 100%;
    // height: 40px;
    border: 0px solid #ffffff;
    display: flex;
    margin-top: 8px;
    // margin-left: 1.8%;
    .toolBtn {
      border-color: transparent;
      font-size: 14px;
      margin-right: 10px;
    }

    .toolClass {
      width: 25%;
      height: 100%;
      text-align: center;
      line-height: 40px;
      border-right: 1px solid #ffffff;
      cursor: pointer;

      span {
        margin-left: 8px;
      }
    }

    .toolClass:last-child {
      border-right: none;
    }

    .toolClassActive {
      width: 25%;
      height: 100%;
      text-align: center;
      line-height: 40px;
      border-right: 1px solid #ffffff;
      background-color: #049191;
      cursor: pointer;

      span {
        margin-left: 8px;
      }
    }

    .toolClassActive:last-child {
      border-right: none;
    }

    /deep/ .ant-row {
      display: flex;
      align-items: center;
    }
    /deep/ .ant-col-7, /deep/ .ant-col-6, /deep/ .ant-col-16 {
      text-align: left;
    }
  }

  .toolInfo {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-top: 4px;

    // border: 1px solid red;
    .drawClass {
      width: 90%;
      height: 100%;
      margin-left: 5%;
      margin-top: 10px;
      display: flex;
      border: 1px solid #ffffff;

      .shapeClass {
        width: 33.33333333333%;
        height: 100%;
        text-align: center;
        line-height: 40px;
        border-right: 1px solid #ffffff;
        cursor: pointer;
      }

      .shapeClass:last-child {
        border-right: none;
      }

      .shapeClassActive {
        width: 33.333333333%;
        height: 100%;
        text-align: center;
        line-height: 40px;
        border-right: 1px solid #ffffff;
        background-color: #049191;
        cursor: pointer;
      }

      .shapeClassActive:last-child {
        border-right: none;
      }
    }
  }

  .oprateMethod {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .oprateIcon {
      width: 25%;
      // margin-left: 1.8%;
      justify-content: space-around;
      cursor: pointer;
      .saveBtn {
        background: rgba(255, 255, 255, 0.2);
        border-color: transparent;
        font-size: 14px;
        margin-right: 10px;
      }
      .iconBtn {
        display: flex;
        font-size: 11px;
        align-items: center;
        margin-right: 11%;
      }
    }
  }

  .oprateInfo {
    width: 100%;
    // margin-left: 1%;
    margin-top: 10px;

    .oprateItem {
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ffffff;
      margin-top: 6px;
      padding-bottom: 8px;
      padding-left: 8px;
      padding-right: 8px;

      .oprateIcon {
        width: 25%;
        display: flex;
        justify-content: space-around;
        cursor: pointer;
      }

      /deep/ .ant-checkbox-wrapper {
        color: #ffffff;
      }
    }
  }

  /deep/.ant-empty-normal {
    margin: 10px 0;
  }

  /deep/ .ant-empty-normal .ant-empty-image {
    height: 24px;
  }

  /deep/ .ant-empty {
    // margin: 0 8px;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
  }

  input,
  select,
  textarea {
    color: #ffffff;
    border: 1px solid #e4eaec;
    font-size: 14px;
  }

  /deep/ .ant-input {
    color: #ffffff;
    border: 0;
    font-size: 14px;
  }
}
/deep/ .ant-btn-link {
  color: #00c981;
  padding: 0 8px;
}

// /deep/ .oprateInfo .ant-spin-container .ant-table .ant-table-content .ant-table-scroll .ant-table-header {
//   overflow: hidden !important;
// }
</style>
  